module.exports = __webpack_public_path__ + "static/media/main idea.3cdf3667.mp3";